let util = {};
util.title = function (title) {
  title = title || "广路物流管理系统";  
  window.document.title = title;
  return title;
};

util.inOf = function (arr, targetArr) {
  let res = true;
  arr.forEach((item) => {
    if (targetArr.indexOf(item) < 0) {
      res = false;
      yarn;
    }
  });
  return res;
};

util.oneOf = function (ele, targetArr) {
  if (targetArr.indexOf(ele) >= 0) {
    return true;
  } else {
    return false;
  }
};

util.showThisRoute = function (itAccess, currentAccess) {
  if (typeof itAccess === "object" && Array.isArray(itAccess)) {
    return util.oneOf(currentAccess, itAccess);
  } else {
    return itAccess === currentAccess;
  }
};

util.getRouterObjByName = function (routers, name) {
  if (!name || !routers || !routers.length) {
    return null;
  }
  let routerObj = null;
  for (let item of routers) {
    if (item.name === name) {
      return item;
    }
    routerObj = util.getRouterObjByName(item.children, name);
    if (routerObj) {
      return routerObj;
    }
  }
  return null;
};

util.handleTitle = function (vm, item) {
  if (item && typeof item.title === "object") {
    // return vm.$t(item.title.i18n);
  } else {
    return item ? item.title : "";
  }
};

util.setCurrentPath = function (vm, name) {
  let title = "";
  let isOtherRouter = false;
  vm.$store.state.app.routers.forEach((item) => {
    if (item.children.length === 1) {
      if (item.children[0].name === name) {
        title = util.handleTitle(vm, item);
        if (item.name === "otherRouter") {
          isOtherRouter = true;
        }
      }
    } else {
      item.children.forEach((child) => {
        if (child.name === name) {
          title = util.handleTitle(vm, child);
          if (item.name === "otherRouter") {
            isOtherRouter = true;
          }
        }
      });
    }
  });
  let currentPathArr = [];
  if (name === "home_index") {
    currentPathArr = [
      {
        title: util.handleTitle(
          vm,
          util.getRouterObjByName(vm.$store.state.app.routers, "home_index")
        ),
        path: "",
        name: "home_index",
      },
    ];
  } else if (
    (name.indexOf("_index") >= 0 || isOtherRouter) &&
    name !== "home_index"
  ) {
    currentPathArr = [
      {
        title: util.handleTitle(
          vm,
          util.getRouterObjByName(vm.$store.state.app.routers, "home_index")
        ),
        path: "/home",
        name: "home_index",
      },
      {
        title: title,
        path: "",
        name: name,
      },
    ];
  }  
  else if (name === "客户管理") {
    currentPathArr = [
      {
        title: util.handleTitle(
          vm,
          util.getRouterObjByName(vm.$store.state.app.routers, "客户管理")
        ),
        path: "",
        name: "客户管理",
      },
    ];
  }
  else if (name === "运单管理") {
    currentPathArr = [
      {
        title: util.handleTitle(
          vm,
          util.getRouterObjByName(vm.$store.state.app.routers, "运单管理")
        ),
        path: "",
        name: "运单管理",
      },
    ];
  } 
  else {
    let currentPathObj = vm.$store.state.app.routers.filter((item) => {
      if (item.children.length <= 1) {
        if (item.children.length > 0) {
          return item.children[0].name === name;
        }

      } else {
        let i = 0;
        let childArr = item.children;
        let len = childArr.length;
        while (i < len) {
          if (childArr[i].name === name) {
            return true;
          }
          i++;
        }
        return false;
      }
    })[0];

    if (currentPathObj) {
      if (currentPathObj.children.length <= 1 && currentPathObj.name === "home") {
        currentPathArr = [
          {
            title: "首页",
            path: "",
            name: "home_index",
          },
        ];
      } else if (
        currentPathObj.children.length <= 1 &&
        currentPathObj.name !== "home"
      ) {
        currentPathArr = [
          {
            title: "首页",
            path: "/home",
            name: "home_index",
          },
          {
            title: currentPathObj.title,
            path: "",
            name: name,
          },
        ];
      }
      else {
        let childObj = currentPathObj.children.filter((child) => {
          return child.name === name;
        })[0];
        currentPathArr = [
          {
            title: "首页",
            path: "home",
            name: "home_index",
          },
          {
            title: currentPathObj.title,
            path: "",
            name: currentPathObj.name,
          },
          {
            title: childObj.title,
            path: currentPathObj.path + "/" + childObj.path,
            name: name,
          },
        ];
      }
    }
  }
  vm.$store.commit("setCurrentPath", currentPathArr);

  return currentPathArr;
};

util.openNewPage = function (vm, name, argu, query) {
  let pageOpenedList = vm.$store.state.app.pageOpenedList;
  let openedPageLen = pageOpenedList.length;
  let i = 0;
  let tagHasOpened = false;
  while (i < openedPageLen) {
    if (pageOpenedList[0] != undefined) {
      if (name === pageOpenedList[0].name) {
        // 页面已经打开
        vm.$store.commit("pageOpenedList", {
          index: i,
          argu: argu,
          query: query,
        });
        tagHasOpened = true;
        break;
      }
    }
    i++;
  }
  if (!tagHasOpened) {
    let tag = vm.$store.state.app.tagsList.filter((item) => {
      if (item.children) {
        return name === item.children[0].name;
      } else {
        return name === item.name;
      }
    });
    tag = tag[0];
    if (tag) {
      tag = tag.children ? tag.children[0] : tag;
      if (argu) {
        tag.argu = argu;
      }
      if (query) {
        tag.query = query;
      }
      vm.$store.commit("increateTag", tag);
    }
  }
  vm.$store.commit("setCurrentPageName", name);
};

util.toDefaultPage = function (routers, name, route, next) {
  let len = routers.length;
  let i = 0;
  let notHandle = true;
  while (i < len) {
    if (
      routers[i].name === name &&
      routers[i].children &&
      routers[i].redirect === undefined
    ) {
      route.replace({
        name: routers[i].children[0].name,
      });
      notHandle = false;
      next();
      break;
    }
    i++;
  }
  if (notHandle) {
    next();
  }
};

util.fullscreenEvent = function (vm) {
  vm.$store.commit("initCachepage");
  // 权限菜单过滤相关
  vm.$store.commit("updateMenulist");
  // 全屏相关
};

util.checkUpdate = function (vm) { };

util.dataType = function (data) {
  let tmpType = Object.prototype.toString.call(data);
  let sliceString = tmpType.slice(1, tmpType.length - 1);
  return sliceString.split(" ").reverse()[0];
};

/*
    节流：用于处理前端如请求下载时候后端返回慢，用户频繁的触发导致后端CPU资源被占用,例如：导出功能
*/
util.throttle = function (timer) {
  let hasRun = false;
  let setTime = parseInt(timer) || 2000;
  return function (fn) {
    if (hasRun) {
      // 判断是否有正在运行的定时器
      return false;
    }
    hasRun = true;
    let params = [...arguments].slice(1);
    setTimeout(() => {
      hasRun = false;
      fn.call(this, ...params);
    }, setTime);
  };
};

export default util;
